import React, {FC} from "react"
import {Grid} from "react-bootstrap"

import Anchor from "@irati/ui/src/Link/styled/Anchor"

import {Nav, PerkboxLogo} from "./styled"

const PERKBOX_HREF = "https://perkbox.com"

const ContactPreferencesNav: FC = () => {
  return (
    <Nav>
      <Grid>
        <Anchor plain href={PERKBOX_HREF} target="_blank" tabIndex={0}>
          <PerkboxLogo />
        </Anchor>
      </Grid>
    </Nav>
  )
}

export default ContactPreferencesNav
